const CoinState = {
    coinType: [],
    coinPreferences: [],
    openOrders: [],
    pendingOrders: [],
};

export default CoinState;